module.exports = __webpack_public_path__ + "media/arrow-down.7b756cca.svg";